

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 試験日程管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" color="danger"  @click="deleteModal = true">削除</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CCol md="8" class="offset-md-2">
                <dl v-for="(k, v) in labelDic" class="row" :key="k">
                  <dt class="col-sm-3">{{k}}</dt>
                  <dd class="col-sm-9">
                    {{formatData(k, v)}}
                  </dd>
                </dl>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      industryTypes: [] ,
      industries: {},
      recordModal: false,
      deleteModal: false,
      record: {},
      labelDic: {
          'date': "開催日時",
          'country': "国",
          'address': "会場",
          'reception_time': "受付時間",
          'application_datetime': "申し込み期間",
          'exam_format': "試験の方式",
          'application_url': "試験の申し込みURL",
          'announce_date': "合格発表日",
          'announce_methods': "合格発表方法",
          'industry_id': "試験業種",
      }
    }
  },
  methods: {
    formatData: function(label, d) {
        var dat = moment(d)
        if(this.record[d] == null) {
          return "--"
        }
        if(dat.isValid() == false) {
          return this.record[d]
        }
        if(d == "date") {
          return moment(this.record[d]).format("YYYY/MM/DD HH:mm")
        } else if(d == "created_at" || d == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else if(d == "reception_time") {
          return moment(this.record["reception_start_time"]).format("HH:mm") + " ~ " + moment(this.record["reception_end_time"]).format("HH:mm")
        } else if(d == "application_datetime") {
          return moment(this.record["application_start_date"]).format("YYYY/MM/DD HH:mm") + " ~ " + moment(this.record["application_end_date"]).format("YYYY/MM/DD HH:mm")
        } else if(d == "announce_date") {
          return moment(this.record[d]).format("YYYY/MM/DD HH:mm")
        } else if(d == "industry_id") {
          return this.industries[this.record["industry_id"]]
        } else {
          return this.record[d]
        }
    },
    updateItem: function() {
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/examinations/" + this.record.id, {"industry": this.record})
        .then(() => {
          this.recordModal = false
        }).catch(error => {
          console.log(error)
        })
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/examinations/" + this.record.id)
        .then(() => {
          this.deleteModal = false
          this.$router.push('/examinations')

        }).catch(error => {
          console.log(error)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/examinations/" + this.$route.params.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.record = response.data
      }).catch(error => {
          console.log(error)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industryTypes = [{
              value: "",
              label: "",
          }]
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          console.log(error)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
